import { lowerPlatform, lowerUserAgent, maxTouchPoints } from "./shared.js";
const ios = /^i(os$|p)/.test(lowerPlatform) || lowerPlatform === "macintel" && maxTouchPoints > 1;
const ANDROID_STRING = "android";
const android = lowerPlatform === ANDROID_STRING || lowerUserAgent.includes(ANDROID_STRING);
const mac = !ios && lowerPlatform.startsWith("mac");
lowerPlatform.startsWith("win");
const apple = mac || ios;
export {
  android,
  apple,
  ios,
  mac
};
//# sourceMappingURL=os.js.map
